// extracted by mini-css-extract-plugin
module.exports = {"ddl-error":"SettingsDdl-module__ddl-error__1spo8","menu-item":"SettingsDdl-module__menu-item__FndOI"};